import { Component } from 'react';

class MediaSizeHelper extends Component {
    static isMobile = () => {
        return window.innerWidth <= 767;
    }
    static isLargeMobile = () => {
        return 450 < window.innerWidth  && window.innerWidth <= 767;
    }
    static isNormalDesktop = () => {
        return 767 < window.innerWidth  && window.innerWidth <= 1800;
    }
    static isLargeDesktop = () => {
        return 1800 < window.innerWidth;
    }
}

export default MediaSizeHelper;
